export default "__VITE_ASSET__BkoQCtQE__"